import React from "react";
import { ColourPallette } from './ColourPallette.js';
import { AnnotationsColorPalette } from './ColourPallette.js';

const Highlighter = ({
    position,
    onClick,
    onMouseOver,
    onMouseOut,
    comment,
    isScrolledTo,
}) => {

    const { rects, boundingRect } = position;

    return (
        <div
            className={`Highlight ${isScrolledTo ? "Highlight--scrolledTo" : ""}`}
        >
            <div className="Highlight__parts">
                {rects.map((rect, index) => {
                    if (comment && comment.type) {
                        var bg = ColourPallette[comment.type];
                        var styleObj = rect;

                        if (rect.height == 0 && rect.width == 0) // This is a coordinate just for scrolling to the page, not to highlight
                            return;

                        styleObj["backgroundColor"] = bg;

                        // For special highlights (when all changes are highlighted at the same time but one specific change was clicked)
                        if (comment.type == "_comparison_deleted_special_") {
                            styleObj["border"] = "1px solid red";
                        }

                        if (comment.type == "_comparison_inserted_special_") {
                            styleObj["border"] = "1px solid green";

                        }


                        return <div
                            onMouseOver={onMouseOver}
                            onMouseOut={onMouseOut}
                            onClick={onClick}
                            key={index}
                            style={rect}
                            className={`Highlight__part`}
                        />
                    } else { 

                        // It's an annotation
                        var bg = AnnotationsColorPalette[comment.colour];
                        var styleObj = rect;
                        styleObj["backgroundColor"] = bg;

                        return <div
                            onMouseOver={onMouseOver}
                            onMouseOut={onMouseOut}
                            onClick={onClick}
                            key={index}
                            style={{...styleObj, backgroundColor: bg}}
                            className="Highlight__part"
                        />  
                     }
                })}
            </div>
        </div>
    );
}

export default Highlighter;